import { Monoid } from 'fp-ts/Monoid'

export const stringSeparatorMonoid: Monoid<string> = {
  empty: '',
  concat: (a, b) => `${a} - ${b}`
}

export const capitalize = (s: string): string => s.substring(0, 1).toUpperCase() + s.substring(1)
